/*
 * The country dropdown across the five Hooray Heroes stores (snippets/hh-store-switcher.liquid).
 *
 * A country this store serves is switched the way Shopify's own selector does it: the hidden
 * country_code input is set and the localization form is submitted. A country another store serves
 * is a plain link to that country's own url on that store. The language list links to another store
 * with the current country carried as ?hh_country=XX (Germany on the English store is not a url of
 * its own), and this script is what honours it on arrival: if the page was opened with hh_country naming a country this store serves and the market
 * is not already that country, the form is submitted once, same-site, so the visitor lands on the
 * right market without ever posting across stores (a cross-site post drops the storefront cookies).
 *
 * Country names arrive in English and are shown in the page's language when the browser can name
 * regions (Intl.DisplayNames), and the list is re-sorted so the order is right in that language too.
 */
(function () {
  // the header and the footer each carry a switcher and each load this script; one run sets up both
  if (window.hhStoreSwitcherLoaded) {
    return;
  }
  window.hhStoreSwitcherLoaded = true;

  function localise(list, lang) {
    if (!window.Intl || !Intl.DisplayNames) {
      return;
    }
    var names;
    try {
      names = new Intl.DisplayNames([lang], { type: 'region' });
    } catch (e) {
      return;
    }
    var items = Array.prototype.slice.call(list.children);
    items.forEach(function (item) {
      var link = item.querySelector('a[data-country]');
      var label = item.querySelector('[data-country-name]');
      if (!link || !label) {
        return;
      }
      var name;
      try {
        name = names.of(link.dataset.country);
      } catch (e) {
        name = null;
      }
      if (name) {
        label.textContent = name;
      }
    });
    items.sort(function (a, b) {
      var an = (a.querySelector('[data-country-name]') || a).textContent.trim();
      var bn = (b.querySelector('[data-country-name]') || b).textContent.trim();
      return an.localeCompare(bn, lang);
    });
    items.forEach(function (item) {
      list.appendChild(item);
    });
  }

  function requestedCountry() {
    var match = /[?&]hh_country=([A-Za-z]{2})(?:&|$)/.exec(window.location.search);
    return match ? match[1].toUpperCase() : null;
  }

  /*
   * Shopify fills the form's return_to with the current path, market prefix included. Leaving the
   * Australian subfolder for the United States then returned the visitor to /en-au, which selected
   * Australia again. The path without the prefix lets Shopify put the new market's own prefix on it.
   */
  function returnPath() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var prefix = root.replace(/\/$/, '');
    var path = window.location.pathname;
    if (prefix !== '' && (path === prefix || path.indexOf(prefix + '/') === 0)) {
      path = path.slice(prefix.length) || '/';
    }
    return path;
  }

  function submitCountry(form, input, code) {
    var back = form.querySelector('input[name="return_to"]');
    if (back) {
      back.value = returnPath();
    }
    input.value = code;
    form.submit();
  }

  function setUp(container, arrival) {
    var form = container.querySelector('form');
    var input = container.querySelector('input[name="country_code"]');
    var list = container.querySelector('ul');
    if (!form || !input || !list) {
      return false;
    }
    localise(list, document.documentElement.lang || 'en');
    list.addEventListener('click', function (event) {
      var link = event.target.closest('a[data-value]');
      if (!link) {
        return;
      }
      event.preventDefault();
      submitCountry(form, input, link.dataset.value);
    });
    if (arrival && arrival !== container.dataset.currentCountry && list.querySelector('a[data-value="' + arrival + '"]')) {
      submitCountry(form, input, arrival);
      return true;
    }
    return false;
  }

  /*
   * The header's copy sits after the menu, and how much room that leaves depends on the store's menu
   * and the window. It is shown whole when it fits on the menu's line clear of the icons, without the
   * language dropdown when only that fits, and not at all otherwise; the footer always has the full one.
   */
  function fitHeader() {
    var selector = document.querySelector('.site-header__inline-menu > .site-header__localization');
    if (!selector) {
      return;
    }
    var nav = selector.parentElement;
    var items = nav.querySelectorAll('.site-header__inline-menu-list > li');
    var icons = Array.prototype.filter.call(
      document.querySelectorAll('.site-header__shop-links summary, .site-header__shop-links a'),
      function (el) { return el.getBoundingClientRect().width > 0; }
    );
    function menuRows() {
      var tops = {};
      Array.prototype.forEach.call(items, function (item) {
        tops[Math.round(item.getBoundingClientRect().top)] = true;
      });
      return Object.keys(tops).length;
    }
    function fits(rowsAlone) {
      var box = selector.getBoundingClientRect();
      if (box.width === 0 || !items.length) {
        return false;
      }
      var first = items[0].getBoundingClientRect();
      var clear = icons.every(function (el) { return box.right <= el.getBoundingClientRect().left - 8; });
      return box.top < first.bottom && clear && menuRows() === rowsAlone;
    }
    selector.classList.add('hh-switcher--hidden');
    var rowsAlone = menuRows();
    selector.classList.remove('hh-switcher--hidden', 'hh-switcher--no-language');
    if (fits(rowsAlone)) {
      return;
    }
    selector.classList.add('hh-switcher--no-language');
    if (!selector.querySelector('[data-hh-language-switcher]') || !fits(rowsAlone)) {
      selector.classList.add('hh-switcher--hidden');
    }
  }

  function watchHeader() {
    fitHeader();
    var pending = false;
    window.addEventListener('resize', function () {
      if (!pending) {
        pending = true;
        window.requestAnimationFrame(function () {
          pending = false;
          fitHeader();
        });
      }
    });
    // the menu's width changes once Poppins arrives
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(fitHeader);
    }
  }

  function init() {
    watchHeader();
    var arrival = requestedCountry();
    var switchers = document.querySelectorAll('[data-hh-country-switcher]');
    Array.prototype.forEach.call(switchers, function (container) {
      if (setUp(container, arrival)) {
        // one submit is enough; the page is about to reload on the requested market
        arrival = null;
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
